<template>
  <span>
    <img v-if="user" :src="imgUrl" class="userAvator" alt />
    <span v-else class="avatortox">{{ user.tox }}</span>
    <span>{{ user.userName || user.name }}</span>
    <span v-if="canDelete" class="deleteBtn" @click="deleteApproveUser(user)">
      <i class="el-icon-delete hand delete" :title="deleteToolTip"></i>
    </span>
  </span>
</template>

<script>
import { gettouxAvatar } from "@/CommonDP/utils";
export default {
  props: {
    user: {
      type: Object,
      default: () => { }
    },
    canDelete: {
      type: Boolean,
      default: false
    },
    confirmDelete: {
      type: Boolean,
      default: true
    },
    customParams: {
      type: [Object, Array, String, Number, Boolean],
      default: () => undefined
    }
  },

  data() {
    return {
      roleIcon: require("@/CommonDP/assets/doc/role.png")
    };
  },

  computed: {
    imgUrl() {
      if (!this.user) {
        return;
      }
      if (this.user.type === 1 || this.user.type === 2) {
        return this.roleIcon;
      }
      return this.user ? gettouxAvatar(this.user.userId) : "";
    },
    deleteToolTip() {
      if (!this.user) {
        return "";
      }
      if (this.user.type === 0) {
        return "删除人员";
      }
      if (this.user.type === 1) {
        return "删除系统角色";
      }
      if (this.user.type === 2) {
        return "删除项目角色";
      }
      return "";
    }
  },

  methods: {
    async deleteApproveUser() {
      if (this.confirmDelete) {
        await this.$confirm("确认 " + this.deleteToolTip + ": " + (this.user.userName || this.user.name) + " ？");
      }
      this.$emit("delete", this.user, this.customParams);
    }
  }
};
</script>

<style scoped>
.userAvator {
  border-radius: 50%;
  width: 16px;
  height: 18px;
  padding-bottom: 2px;
  margin-right: 0px;
  display: inline-block;
  vertical-align: middle;
}

.avatortox {
  border-radius: 50%;
  width: 16px;
  height: 16px;
  line-height: 32px;
  margin: 0 auto;
  margin-top: 0px;
  border: 1px solid #4777e7;
  background: #4777e7;
  color: #fff;
  display: inline-block;
  vertical-align: top;
  text-align: center;
}

.hand {
  cursor: pointer;
}
.deleteBtn {
  margin-left: 5px;
}
</style>
